/* eslint-disable react/prop-types */
/*
 *
 * This is the page rendered in our App, at the '/' route
 *
 *  This page is used for user login. After login the user can
 *  book appointment see his or her records prescription and appointments
 *
 * NOTE: while this component should technically be a stateless functional
 * component (SFC), hot reloading does not currently support SFCs. If hot
 * reloading is not a necessity for you then you can refactor it and remove
 * the linting exception.
 *
 * This page is the first page rendered in the app
 *
 *The import message and formattedMessage is used for localisation
 */

import React, { useEffect, useState } from 'react';
import { Card, Row, Col, Form, Input, Button, Checkbox, Carousel, Radio } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
// import { FormattedMessage } from 'react-intl';
import { LockOutlined, UserOutlined } from '@ant-design/icons';
// import 'antd/dist/antd.css';
// import messages from './messages';
import './style.css';
import { fetchLoginRequest } from './Actions';
import { ButtonText } from '../CommonText';
import { selectError, selectRedirectUrl } from './Selectors';

import english from '../../Translations/English.json';
import hindi from '../../Translations/Hindi.json';
import malayalam from '../../Translations/Malayalam.json';

const CaroRepeat = ({ classname }) => {
    
    const langid = localStorage.getItem('INTL') ? (localStorage.getItem('INTL')) : 'en';
    const langdata = langid && langid == 'en' ? english : langid == 'ma' ? malayalam : langid == 'hin' ? hindi : english;

    return(
        <div>
            <Card className={classname}>
                <div style={{ marginBottom: '100%' }}>
                    <div>
                        <h1
                            style={{
                                color: '#fff',
                                fontSize: 30,
                                fontFamily: 'Roboto',
                                marginTop: '37%',
                            }}
                        >
                            <strong>{langdata.Findtrustedmedicaladvicefrom150000topdoctors ? langdata.Findtrustedmedicaladvicefrom150000topdoctors : 'Find trusted medical advice from 1,50,000 top doctors' }</strong>
                        </h1>
                    </div>
                </div>
            </Card>
        </div>
    );};

const Login = ({ requesting }) => {
    const [form] = Form.useForm();
    const [radioEmailOrPhone, setRadioEmailOrPhone] = useState(1);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { state } = useLocation();
    const [passwordVisible, setPasswordVisible] = useState(false);

    const redirectUrl = useSelector(selectRedirectUrl);
    const error = useSelector(selectError);

    const langid = localStorage.getItem('INTL') ? (localStorage.getItem('INTL')) : 'en';
    const langdata = langid && langid == 'en' ? english : langid == 'ma' ? malayalam : langid == 'hin' ? hindi : english;
    const redirectfullUrl = localStorage.getItem('redirectfullUrl');

    if (redirectUrl) {
        if(redirectfullUrl){
            navigate(redirectfullUrl);
        }
        else if(state){
            navigate(('/online-doctors-consultation'), {state : state});
        }else {
            navigate(redirectUrl);
        }
    }

    useEffect(() => {
        if (error) {
            // Clear form fields on error
            form.resetFields(['password']);
        }
    }, [error, form]);

    const handleSubmit = (e) => {
        dispatch(fetchLoginRequest(e, radioEmailOrPhone));
    };

    const onChange = (e) => {
        setRadioEmailOrPhone(e.target.value);
        localStorage.setItem('LOGIN_IS_THROUGH', e.target.value === 1 ? 'email' : 'phone');
    };

    const checkCheckBox = (_, value) => {
        if (!value) {
            return Promise.reject(new Error('Please agree the terms and conditions!'));
        }
        return Promise.resolve();
    };

    const phoneValidator = (_, value) => {
        if (value && !/^[0-9]{7,11}$/.test(value)) {
            return Promise.reject(new Error('Phone number not valid!'));
        }
        return Promise.resolve();
    };

    return (
        <div style={{ marginTop: '2%', marginBottom: '2%' }}>
            <Row>
                <Col>
                    <Row>
                        <Col
                            xs={{ span: 22, offset: 1 }}
                            md={{ span: 12, offset: 1 }}
                            lg={{ span: 6, offset: 4 }}
                            xl={{ span: 6, offset: 4 }}
                            xxl={{ span: 6, offset: 6 }}
                        >
                            <Card style={{ height : 415}}>
                                <Col
                                    sm={{ span: 23, offset: 1 }}
                                    lg={{ span: 24, offset: 0 }}
                                    xl={{ span: 22, offset: 2 }}
                                    xxl={{ span: 16, offset: 5 }}
                                >
                                    <Form form={form} onFinish={handleSubmit} className="login-form">
                                        <Row>
                                            <Col span={24}>
                                                <Radio.Group onChange={onChange} value={radioEmailOrPhone}>
                                                    <Radio.Button value={1}>
                                                        {/* <FormattedMessage {...messages.email} />{' '} */}
                                                        {`${langdata.email ? langdata.email : 'Email'}`}
                                                    </Radio.Button>
                                                    <Radio.Button value={2}>
                                                        {/* <FormattedMessage {...messages.phone} />{' '} */}
                                                        {`${langdata.phone ? langdata.phone : 'Phone'}`}
                                                    </Radio.Button>
                                                </Radio.Group>
                                            </Col>
                                            <Col span={22} style={{ marginTop: '7%' }}>
                                                {radioEmailOrPhone === 1 ? (
                                                    <Form.Item
                                                        name="email"
                                                        rules={[
                                                            {
                                                                type: 'email',
                                                                required: true,
                                                                message: 'Please input your email!',
                                                            },
                                                        ]}
                                                    >
                                                        <Input
                                                            prefix={<UserOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
                                                            placeholder="Email"
                                                            size="large"
                                                        />
                                                    </Form.Item>
                                                ) : (
                                                    <Form.Item
                                                        name="phone"
                                                        rules={[
                                                            { required: true, message: 'Please input your Phone!' },
                                                            { validator: phoneValidator },
                                                        ]}
                                                    >
                                                        <Input
                                                            prefix={<UserOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
                                                            placeholder="Phone"
                                                            size="large"
                                                        />
                                                    </Form.Item>
                                                )}
                                            </Col>
                                            <Col span={22} style={{ marginTop: '-5px' }}>
                                                <Form.Item
                                                    name="password"
                                                    rules={[{ required: true, message: 'Please input your Password!' }]}
                                                >
                                                    <Input.Password
                                                        prefix={<LockOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
                                                        type="password"
                                                        placeholder="Password"
                                                        size="large"
                                                        visibilityToggle={{
                                                            visible: passwordVisible,
                                                            onVisibleChange: setPasswordVisible,
                                                        }}
                                                    />
                                                </Form.Item>
                                            </Col>

                                            <Col span={22} style={{ marginTop: '-5px' }}>
                                                <Form.Item
                                                    name="agreement"
                                                    valuePropName="checked"
                                                    rules={[{ validator: checkCheckBox }]}
                                                >
                                                    <Checkbox>
                                                        I have accepted the{' '}
                                                        <a
                                                            target="blank"
                                                            href="https://quikdr.com/healthtips/privacy-policy-quikdr-health-tips/"
                                                        >
                                                            terms and conditions
                                                        </a>
                                                    </Checkbox>
                                                </Form.Item>
                                                <Col sm={{ span: 24 }} style={{ marginTop: '-15px' }}>
                                                    <Row>
                                                        <Col span={16}>
                                                            <Form.Item
                                                                name="remember"
                                                                valuePropName="checked"
                                                                initialValue={true}
                                                            >
                                                                <Checkbox style={{ color: '#ccced2' }}>
                                                                    {/* <FormattedMessage {...messages.remeber} /> */}
                                                                    {`${langdata.remeber ? langdata.remeber : 'Remember' }`}
                                                                </Checkbox>
                                                            </Form.Item>
                                                        </Col>
                                                        <Col span={8}>
                                                            <Button
                                                                type="primary"
                                                                htmlType="submit"
                                                                style={{
                                                                    float: 'right',
                                                                    fontFamily: 'Roboto',
                                                                    fontSize: 'large',
                                                                    // paddingTop : 'inherit'
                                                                }}
                                                                size="large"
                                                                loading={requesting}
                                                            >
                                                                {/* <FormattedMessage {...messages.login} /> */}
                                                                <ButtonText text={`${langdata.login ? langdata.login : 'Login' }`} />
                                                            </Button>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                                <Col
                                                    xs={{ span: 24 }}
                                                    sm={{ span: 23, offset: 1 }}
                                                    style={{ textAlign: 'center', marginTop: '-10px' }}
                                                >
                                                    <a
                                                        className="login-form-forgot"
                                                        href="/forgotpassword"
                                                        style={{ float: 'right', color: '#ccced2' }}
                                                    >
                                                        {/* <FormattedMessage {...messages.forgotPassword} /> ? */}
                                                        {`${langdata.forgotPassword ? langdata.forgotPassword : 'Forgot Password ?' }`}
                                                    </a>
                                                </Col>
                                                <Col sm={{ span: 24 }}>
                                                    <div style={{ textAlign: 'center', marginTop: '30px' }}>
                                                        <Button
                                                            type="primary"
                                                            size="large"
                                                            style={{ width: '100%', fontFamily: 'Roboto', fontSize: 'large' }}
                                                            onClick={() => navigate('/register')}
                                                        >
                                                            <ButtonText text={`${langdata.RegisterNow ? langdata.RegisterNow : 'Register Now!'}`} />
                                                        </Button>
                                                    </div>
                                                </Col>
                                                {/* </Form.Item> */}
                                            </Col>
                                        </Row>
                                    </Form>
                                </Col>
                            </Card>
                        </Col>
                        <Col
                            xs={{ span: 0 }}
                            sm={{ span: 0 }}
                            md={{ span: 10 }}
                            xl={{ span: 10 }}
                            xxl={{ span: 12 }}
                        >
                            <Carousel autoplay>
                                <CaroRepeat classname="caro1" />
                                <CaroRepeat classname="caro2" />
                                <CaroRepeat classname="caro3" />
                                <CaroRepeat classname="caro4" />
                            </Carousel>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </div>
    );
};

Login.propTypes = {
    requesting: PropTypes.bool,
};

export default Login;
